import React from "react";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import { TextField } from "@material-ui/core";
import { BuyGetStatus } from "../../../../types/product/ibrief-product/buy-get-status.enum";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import styled from "@emotion/styled";
import { ProductsTablePositionColumnProps } from "./products-table-position-column.props";
import { Controller } from "react-hook-form";

export const ProductsTablePositionColumn = withShowIf((props: ProductsTablePositionColumnProps) => {
  const isGet = () => props.buyGetStatus === BuyGetStatus.Get;

  const name = `products.${props.index}.positionText`;

  return (
    <ResponsiveTableCell className="medium" align="left" size="small">
      <PositionText showIf={!isGet()}>
        <Controller
          control={props.control}
          name={`${name}` as const}
          render={(render) => (
            <TextField
              {...render.field}
              disabled={props.disabled}
              onBlur={props.onBlur}
              className="form-control underlined"
              InputProps={{
                style: { fontSize: "13px" },
              }}
            />
          )}
        />
      </PositionText>
    </ResponsiveTableCell>
  );
});

const PositionText = withShowIf(styled.div``);
